export const companyAvatarColors = {
  companyAvatarBackgroundColor: "#C9CEC2",
  companyAvatarLetterColor: "#5C7538"
}
